import { SuscriptionFormData } from "@/formTypes/ProfileFormDataType";
import { EDITOR_INPUT, FILE_UPLOAD_INPUT, HIDDEN_INPUT_TYPE, PHONE_INPUT_TYPE, SECRET_INPUT_TYPE, SELECT_INPUT_TYPE, Yup } from "@mavichpe/dynamic-forms";
import { DEFAULT_DETAIL_FONT_SIZE, DETAIL_FONT_SIZES, FORMATOS_IMPRESION, PRICE_MANAGEMENT_OPTIONS, TIPOS_DE_IDENTIFICACION } from "@utils/Constants";
import { FormFileServer } from "@utils/FormFileServer";
import { nombreComercialValidation, withIdentificationFormat, withPhoneFormat } from "@utils/Forms";
import { CR_CANTONS, CR_DISTRICTS, CR_NEIBOARD, CR_PROVINCES } from "@utils/LocationData";

const ProfileFormConfig = {
    sections: [
        {
            "title": "Informacion General",
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "nombre",
                        "label": "Nombre Suscripcion",
                        "sizing": {
                            "sm": 5
                        },
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "text",
                        "name": "nombre_comercial",
                        "label": "Nombre Comercial",
                        "sizing": {
                            "sm": 4
                        },
                        "maxlength": 80,
                        "validation": nombreComercialValidation(),
                    },
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "tipo_identificacion",
                        "label": "Tipo identificacion",
                        "sizing": {
                            "sm": 3
                        },
                        "options": TIPOS_DE_IDENTIFICACION,
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "text",
                        "name": "identificacion",
                        "label": "Identificacion",
                        "validation": withIdentificationFormat(Yup.string().notRequired()),
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "email",
                        "label": "Email",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": PHONE_INPUT_TYPE,
                        "name": "telefono1",
                        "label": "Telefono 1",
                        "validation": withPhoneFormat(Yup.string().notRequired()),
                    },
                    {
                        "type": PHONE_INPUT_TYPE,
                        "name": "telefono2",
                        "label": "Telefono2",
                        "validation": withPhoneFormat(Yup.string().notRequired()),
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "pais",
                        "label": "Pais",
                        "options": {
                            "": "Seleccione Uno",
                            "CRI": "Costa Rica"
                        },
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "province_id",
                        "label": "Provincia",
                        "reFetchAfter": ["pais"],
                        "optionsFunction": (formdata: SuscriptionFormData) => {
                            if (formdata["pais"] && formdata["pais"] == "CRI") {
                                return CR_PROVINCES
                            }
                            return {}
                        }
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "canton_id",
                        "label": "Canton",
                        "reFetchAfter": ["pais", "province_id"],
                        "optionsFunction": (formdata: SuscriptionFormData) => {
                            if (formdata["province_id"]) {
                                return CR_CANTONS
                                    .filter(c => c.province_id == formdata["province_id"])
                                    .reduce((a, c) => {
                                        return {
                                            ...a,
                                            [c.canton_id]: c.name
                                        }

                                    }, {});
                            }
                            return {}
                        }
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "district_id",
                        "label": "Distrito",
                        "reFetchAfter": ["pais", "province_id", "canton_id"],
                        "optionsFunction": (formdata: SuscriptionFormData) => {
                            if (formdata["canton_id"]) {
                                return CR_DISTRICTS
                                    .filter(d => d.canton_id == formdata["canton_id"])
                                    .reduce((a, c) => {
                                        return {
                                            ...a,
                                            [c.district_id]: c.name
                                        }
                                    }, {});
                            }
                            return {}
                        }
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "neiboard_id",
                        "label": "Barrio",
                        "reFetchAfter": ["pais", "province_id", "canton_id", "district_id"],
                        "optionsFunction": (formdata: SuscriptionFormData) => {
                            if (formdata["district_id"]) {
                                return CR_NEIBOARD
                                    .filter(d => d.district_id == formdata["district_id"])
                                    .reduce((a, c) => {
                                        return {
                                            ...a,
                                            [c.neabord_id]: c.name
                                        }
                                    }, {});
                            }
                            return {}
                        }
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "direccion",
                        "label": "Direccion",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
            ]
        },
        {
            "title": "Configuracion Addicional",
            "fields": [
                [
                    {
                        "type": "number",
                        "min": 0,
                        "name": "items_per_page",
                        "label": "Articulos por documento",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "detail_font_size",
                        "label": "Tamaño letra detalle",
                        "options": DETAIL_FONT_SIZES,
                        "default": DEFAULT_DETAIL_FONT_SIZE,
                    },
                    {
                        "type": "text",
                        "name": "last_copy_name",
                        "label": "Nombre Ultima Copia",
                        "default": "Copia"
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "number",
                        "min": 0,
                        "name": "aditional_ticket_copy",
                        "label": "Copias Adicionales Ticket",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "quick_save_button",
                        "label": "Quick save button",
                        "options": {
                            "121": "F10",
                            "122": "F11",
                            "123": "F12"
                        }
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "name": "formato_impresion",
                        "label": "Formato impresion",
                        "type": SELECT_INPUT_TYPE,
                        "options": FORMATOS_IMPRESION,
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "text",
                        "name": "printer_url",
                        "label": "Printer url"
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "prefijo_facturacion",
                        "label": "Prefijo facturacion",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "number",
                        "name": "dias_apartado",
                        "label": "Vencimiento Apartados",
                        "suffix": "dias"
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "number",
                        "name": "dias_notadebito",
                        "label": "Vencimiento Notas Debito",
                        "suffix": "dias"
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "reference_label",
                        "label": "Etiqueta de Campo de Referencia"
                    },
                    {
                        "type": "number",
                        "name": "imp_servicio",
                        "label": "Impuestos de servicio",
                        "suffix": "%"
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "invoice_order",
                        "label": "Orden de Facturacion",
                        "options": {
                            "1": "Codigo, Descripcion, Cant, Precio,Subtotal",
                            "2": "Codigo, Cant, Descripcion, Precio, Subtotal"
                        },
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "pricemanaged",
                        "label": "Tipo Manejo de Precios",
                        "options": PRICE_MANAGEMENT_OPTIONS,
                        "sizing": {
                            "sm": 4
                        },
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "percent_per_item",
                        "label": "Permitir modificar el porcentaje de ganancia en cada producto",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "order_recibe_by_created",
                        "label": "Ordenar recibos por fecha de Creacion?",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "reduce_stock_on_settlement",
                        "label": "Reducir Inventario en Liquidaciones?",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "is_interest_on_due",
                        "label": "Generar intereses por Facturas y liquidaciones vencidos",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    // Los ids de producto son lo unico que se persiste; los inputs visibles
                    // muestran el codigo y la descripcion (ver *_product_label). Van en su
                    // propia fila porque un input oculto se renderiza sin columna y quedaria
                    // como un elemento suelto en medio de los campos visibles.
                    {
                        "type": HIDDEN_INPUT_TYPE,
                        "name": "interest_product_id",
                    },
                    {
                        // Producto que se agrega como linea cuando el envio lo realiza el
                        // propio suscriptor: de el salen el CABYS y el impuesto de la linea.
                        "type": HIDDEN_INPUT_TYPE,
                        "name": "shipping_product_id",
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "interest_on_due",
                        "label": "Interes Mensual por Vencimiento",
                        "suffix": "%",
                        "visibleIf": {
                            "is_interest_on_due": true
                        },
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "text",
                        "name": "interest_product_label",
                        "label": "Producto para Cobro de Intereses",
                        "exludeFromSubmit": true,
                        "visibleIf": {
                            "is_interest_on_due": true
                        },
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "shipping_product_label",
                        "label": "Producto Facturacion de Costo de Envio",
                        "exludeFromSubmit": true,
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "create_shipping_guide",
                        "label": "Crear guia de envio al agregar costo de envio a factura",
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "auto_fit_comments_font",
                        "label": "Ajustar tamaño de fuente de comentarios dinamicamente",
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "show_reference",
                        "label": "Mostrar Campo Referencia en Documentos",
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "show_zone_saleman_on_clients",
                        "label": "Mostrar informacion de Zona y Vendedor en lista de clientes",
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "quote_approval_flow",
                        "label": "Activar proceso de aprobacion de cotizaciones",
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "block_on_limit",
                        "label": "Limitar facturacion por Limite de credito",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "auto_print",
                        "label": "Auto Imprimir Documentos",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "ask_confirm",
                        "label": "Confirmar creacion de Documentos",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "no_auto_cancel_contado",
                        "label": "Crear Recibo de Dinero para cancelar facturas de contado?",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "aplicar_imp_servicio",
                        "label": "Aplicar Impuesto de Servicio",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "comision_producto",
                        "label": "Activar Comision Por Producto",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "include_full_desc",
                        "label": "Include Descripcion Larga en Facturacion",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "inventario_negativo",
                        "label": "Permitir Inventario Negativo",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "show_taxpercent",
                        "label": "Mostar Columna de Impuestos",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "recalculateCurrency",
                        "label": "Recalcular productos por cambio de moneda",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "bank_account_on_docs",
                        "label": "Incluir la informacion de cuentas bancarias en los documento de clientes (Facturas, Cotizacion, Ordenes)",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "disabled_acl",
                        "label": "Desabilitar Control de Acceso (ACL)",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "auto_cancel_rejected",
                        "label": "Anular facturas rechazadas automáticamente",
                        // Solo visible para beta testers (la función está en beta).
                        "visibilityHiddenIf": (formData: SuscriptionFormData) => !formData?.beta_tester,
                    }
                ]
            ]
        },
        {
            "title": "Facturacion Electronica",
            "fields": [
                [
                    {
                        "type": "checkbox",
                        "name": "sync_dolar",
                        "label": "Sincronzar tipo de Cambio con Hacienda?",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "einvoice_status",
                        "label": "Activar Facturacion Electronica",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "einvoice_sandbox",
                        "label": "Usar como fase de Pruebas (Sandbox)",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": FILE_UPLOAD_INPUT,
                        "name": "einvoice_p12",
                        "label": "Archivo de Firma Digital (p12)",
                        "inputConfig": {
                            "server": FormFileServer(),
                            "maxFiles": 1,
                            "allowMultiple": false,
                            "instantUpload": false,
                        },
                    },
                    {
                        "type": SECRET_INPUT_TYPE,
                        "name": "einvoice_password",
                        "label": "Password de Firma Digital",
                        "autocomplete": "new-password"
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "einvoice_atvuser",
                        "label": "Usuario API Tributacion"
                    },
                    {
                        "type": SECRET_INPUT_TYPE,
                        "name": "einvoice_atvpassword",
                        "label": "Password Usuario API"
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "bcc_email",
                        "label": "Enviar Copia Oculta al Correo"
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "use_easypos_email",
                        "label": "Usar correo de Easypos para envío de documentos"
                    }
                ],
            ]
        },
        {
            "title": "Configuracion Logos",
            "fields": [
                [
                    {
                        "type": "checkbox",
                        "name": "use_alternative_icon",
                        "label": "Mostrar Logo Alternativo"
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "select_logo",
                        "label": "Seleccionar Logo en Factura",
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": FILE_UPLOAD_INPUT,
                        "name": "logo",
                        "label": "Logo",
                        "validation": Yup.mixed().required().test(
                            'non-empty', 'Este campo es requerido', value => {
                                if (typeof value === 'string') {
                                    return value.trim().length > 0;
                                }

                                if (typeof value === 'object' && value !== null) {
                                    return Object.keys(value).length > 0;
                                }

                                return false;
                            }
                        ),
                        "inputConfig": {
                            "server": FormFileServer(),
                            "maxFiles": 1,
                            "allowMultiple": false,
                            "instantUpload": false,
                        }
                    },
                    {
                        "type": FILE_UPLOAD_INPUT,
                        "name": "logo2",
                        "label": "Logo Alternativo",
                        "inputConfig": {
                            "server": FormFileServer(),
                            "maxFiles": 1,
                            "allowMultiple": false,
                            "instantUpload": false,
                        },
                    },
                    {
                        "type": FILE_UPLOAD_INPUT,
                        "name": "logo3",
                        "label": "Logo Alternativo 2",
                        "inputConfig": {
                            "server": FormFileServer(),
                            "maxFiles": 1,
                            "allowMultiple": false,
                            "instantUpload": false,
                        },
                    }
                ],
                [
                    {
                        "type": FILE_UPLOAD_INPUT,
                        "name": "watermark",
                        "label": "Marca de Agua Documentos",
                        "sizing": {
                            "sm": 4
                        },
                        "inputConfig": {
                            "server": FormFileServer(),
                            "maxFiles": 1,
                            "allowMultiple": false,
                            "instantUpload": false,
                        },
                    }
                ]
            ]
        },
        {
            "title": "Notas Al Pie",
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": EDITOR_INPUT,
                        "name": "invoice_info",
                        "label": "Facturas"
                    }
                ],
                [
                    {
                        "type": EDITOR_INPUT,
                        "name": "quote_info",
                        "label": "Cotizaciones"
                    }
                ],
                [
                    {
                        "type": EDITOR_INPUT,
                        "name": "hold_info",
                        "label": "Apartados"
                    }
                ],
                [
                    {
                        "type": EDITOR_INPUT,
                        "name": "order_info",
                        "label": "Ordenes de Compra"
                    }
                ],
                [
                    {
                        "type": EDITOR_INPUT,
                        "name": "settlement_info",
                        "label": "Liquidaciones"
                    }
                ],
            ]
        }
    ],
};


export default ProfileFormConfig;